<script>

export default {
	name: 'CheckboxToggle',
	
	components: {
	
	},
	
	data() {
		return {
			workingData:{}
		}
	},
	
	props: {'isDisabled':Boolean, 'data': Object},
	emits: ["onClick"],

	mounted:function(){
		this.workingData=this.data;
	},
	
	methods: {
		handleClick(){
			this.$emit('onClick',this.workingData)
		}
	},	
	
	watch: {
		data() {
			this.workingData=this.data;
		},
	},

	computed:{
		
	},
	
}
</script>

<template>
	<div>
		<div class="togglebutton">
			<label>
				<input v-model='workingData.isActive' :disabled="isDisabled" @click="handleClick" type="checkbox" >
				<span class="toggle"></span>
			</label>
		</div>
	</div>
</template>


